<template>
  <helper-layout :loaded="mx_loaded">
    <material-table
      :search-data="searchData"
      :headers="headers"
      :items="stateMentList.items"
      :paginate="paginateConfig"
      :total-count="stateMentList.totalCount"
      @pageChange="handlePageChange"
      @searchChange="handleSearchChange"
    >
      <!-- 表格顶部工具栏 -->
      <template v-slot:toolbar>
        <v-layout justify-end class="toolbar">
          <v-flex shrink>
            <v-btn v-if="getPermission('FinanceManager.Remittance.ImportBankStatement')" solid @click="importFlow">
              {{ $t('Views.Finance.importFlow') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </material-table>

    <material-dialog :width="500" :visible="showModal" :title="$t('Views.Statement.manualManage')" @cancleFn="cancelDialog" @confirmFn="confirmDialog">
      <template>
        <div class="manual-box">
          <v-form ref="manualForm">
            <v-text-field :value="manualData.operateDate | dateFmt" :label="$t('Views.Statement.operateDate')" disabled />
            <v-text-field :value="manualData.tradeDate | dateFmt" :label="$t('Views.Statement.tradeDate')" disabled />
            <v-text-field :value="manualData.remittanceName" :label="$t('Views.Statement.remittanceName')" disabled />
            <v-text-field :value="manualData.amount | tothousands" :label="$t('Views.Statement.amount')" disabled />
            <material-auto-search
              v-model="manualData.customerId"
              url="/api/Customer/All"
              :param.sync="customerParam"
              search-key="filter"
              required
              clearable
              hide-no-data
              hide-selected
              item-text="name"
              item-value="id"
              :label="$t('Views.Statement.customerName')"
              :filter="handleCustomerFilter"
              :placeholder="$t('Views.Customer.name')"
            />
            <v-checkbox v-model="manualData.IsAddRemittance" :label="$t('Views.Statement.isAddRemittance')" />
            <p>{{ $t('Views.Statement.remark') }}</p>
          </v-form>
        </div>
      </template>
    </material-dialog>
    <material-dialog :width="400" :visible="deleteDialog" :title="$t('Views.Order.sure')" @cancleFn="cancelDelete" @confirmFn="confirmDelete">
      <template>
        {{ $t('Views.Finance.sureDelete') }}
      </template>
    </material-dialog>
  </helper-layout>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins'
import ENUMS from '@/dict/enums'
export default {
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      deleteDialog: false,
      customerParam: { filter: '', status: 'Active' },
      // 表格header栏配置
      headers: [
        {
          // 流水导入日期
          text: $t('Views.Statement.operateDate'),
          value: 'operateDate',
          type: 'date'
        },
        {
          // 汇款日期
          text: $t('Views.Statement.tradeDate'),
          value: 'tradeDate',
          type: 'date'
        },
        {
          // 汇款人账户名
          text: $t('Views.Statement.remittanceName'),
          value: 'remittanceName'
        },
        {
          // 汇款金额
          text: $t('Views.Statement.amount'),
          value: 'amount',
          width: 150,
          render: (h, params) => {
            return h('span', this.$util.data.moneyFmt(params.row.amount))
          }
        },
        {
          // 未分配金额
          text: $t('Views.Order.unallocatedSmount'),
          align: 'right',
          width: 150,
          render: (h, params) => {
            return h('div', this.$util.data.moneyFmt(params.row.dispatchBalance, params.row.currencyName))
          }
        },
        {
          // 匹配状态
          text: $t('Views.Statement.isMatched'),
          render: (h, params) => {
            return h('span', ENUMS.statementMatchStatus[params.row.isMatched])
          }
        },
        {
          // 处理类型
          text: $t('Views.Statement.operateType'),
          render: (h, params) => {
            return h('span', params.row.operateType ? ENUMS.statementOperateType[params.row.operateType] : '--')
          }
        },
        {
          // 入金分配状态
          text: $t('Views.Statement.paymentStatus'),
          value: 'status',
          render: (h, params) => {
            return h('span', ENUMS.statementStatus[params.row.status])
          }
        },
        {
          // 客户名
          text: $t('Views.Statement.customerName'),
          value: 'customerName'
        },
        {
          // 所属销售
          text: $t('Views.Statement.customerSales'),
          value: 'customerSales'
        },
        {
          // 操作
          text: $t('Views.Goods.action'),
          value: 'action',
          width: 160,
          actions: [
            {
              // 手动处理
              text: $t('Views.Statement.manualManage'),
              color: this.$store.state.app.payInfoBtnColor,
              visible: params => {
                return !params.row.isMatched && this.getPermission('FinanceManager.Remittance.Manual')
              },
              actionFn: row => {
                this.showModal = true
                this.manualData = { ...row.row, IsAddRemittance: false }
              }
            },
            {
              // 入金分配
              text: $t('Views.Finance.confirmPay'),
              color: this.$store.state.app.payBtnColor,
              visible: param =>
                param.row.dispatchBalance &&
                param.row.dispatchBalance > 0 &&
                param.row.status === 'Pending' &&
                param.row.isMatched &&
                this.$util.tool.hasPerm('FinanceManager.Remittance.ConfirmPayment'),
              actionFn: param => {
                this.$router.push({
                  name: 'accountStatement_confirm',
                  query: {
                    id: param.row.id,
                    state: 'confirm'
                  }
                })
              }
            },
            {
              // 查看
              text: $t('Core.Action.view'),
              color: this.$store.state.app.color,
              visible: param => param.row.dispatchBalance !== param.row.amount,
              actionFn: param => {
                this.$router.push({
                  name: 'accountStatement_detail',
                  query: {
                    id: param.row.id,
                    state: 'detail'
                  }
                })
              }
            },
            {
              // 删除
              text: $t('Core.Action.delete'),
              color: this.$store.state.app.banBtnColor,
              visible: params => {
                return (
                  (!params.row.isMatched || (params.row.status === 'Pending' && params.row.isMatched)) &&
                  this.getPermission('FinanceManager.Remittance.Delete') &&
                  params.row.amount === params.row.dispatchBalance
                )
              },
              actionFn: params => {
                this.deleteDialog = true
                this.delId = params.row.id
              }
            }
          ]
        }
      ], // 表格数据检索配置
      searchData: [
        {
          key: 'tradeDate',
          label: $t('Views.Statement.tradeDate'),
          type: 'date',
          value: '',
          icon: 'mdi-calendar',
          maxDate: new Date().toISOString()
        },
        {
          key: 'name',
          value: '',
          label: $t('Views.Statement.remittanceName'),
          placeholder: $t('Views.Statement.remittanceNamePlaceholder')
        },
        {
          key: 'isMatched',
          value: '',
          label: $t('Views.Statement.isMatched'),
          placeholder: $t('Views.Goods.allStatus'),
          type: 'select',
          state: [
            {
              value: true,
              label: ENUMS.statementMatchStatus[true]
            },
            {
              value: false,
              label: ENUMS.statementMatchStatus[false]
            }
          ]
        },
        {
          key: 'operateType',
          value: '',
          label: $t('Views.Statement.operateType'),
          placeholder: $t('Views.Goods.allStatus'),
          type: 'select',
          state: [
            {
              value: 'Auto',
              label: ENUMS.statementOperateType.Auto
            },
            {
              value: 'Manual',
              label: ENUMS.statementOperateType.Manual
            }
          ]
        },
        {
          key: 'saleId',
          name: $t('Views.Statement.customerSales'),
          placeholder: $t('Views.Customer.selectSales'),
          type: 'select',
          itemText: 'name',
          itemValue: 'id',
          id: '',
          state: []
        },
        {
          key: 'status',
          label: $t('Views.Statement.paymentStatus'),
          value: '',
          placeholder: $t('Views.Customer.selectStatus'),
          type: 'select',
          state: [
            {
              value: 'Pending',
              label: $t('Views.Statement.pending')
            },
            {
              value: 'Processed',
              label: $t('Views.Statement.processed')
            }
          ]
        }
      ], // 表格分页配置
      paginateConfig: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      // 表格搜索项
      form: {
        tradeDate: '',
        name: '',
        saleId: '',
        isMatched: '',
        operateType: '',
        skipCount: 0,
        maxResultCount: 10
      },
      showModal: false,
      manualData: {},
      delId: '' // 删除流水的id
    }
  },
  computed: {
    ...mapState('finance', ['stateMentList']),
    ...mapState('setting', ['staffAllData']),
    ...mapState('login', ['userInfo'])
  },
  mounted() {
    this.searchData[2].value = this.$route.query.isMatched
    this.form.isMatched = this.$route.query.isMatched
    if (this.$route.query.status) {
      this.searchData[5].value = this.$route.query.status
      this.form.status = this.$route.query.status
      // 所属销售赋值
      this.searchData[4].value = this.userInfo && this.userInfo.isSales ? this.userInfo.staffId : ''
      this.form.saleId = this.userInfo && this.userInfo.isSales ? this.userInfo.staffId : ''
    }
    this.getPage()
    this.getStaff()
  },
  methods: {
    ...mapActions('finance', ['getStatementList', 'manageStatement', 'delStatement']),
    ...mapActions('setting', ['getStaffAllData']),
    confirmDelete() {
      this.delStatement({ id: this.delId }).then(() => {
        this.deleteDialog = false
        this.getPage()
      })
    },
    cancelDelete() {
      this.deleteDialog = false
    },
    getPage(page) {
      if (typeof page !== 'undefined') {
        this.paginateConfig.page = page
        this.form.skipCount = (page - 1) * this.form.maxResultCount
      }
      if (!this.mx_loaded) this.mx_loading_fn() // 页面加载中
      this.getStatementList(this.form).then(() => {
        this.paginateConfig.total = this.stateMentList.totalCount
        this.mx_loaded_fn() // 页面加载完成
      })
    },
    // 获取销售列表
    getStaff() {
      this.getStaffAllData({ isActive: true, permissionCheck: true }).then(() => {
        this.searchData[4].state = this.staffAllData.items
      })
    },
    handleCustomerFilter(item, text, itemText) {
      if (itemText || item.serialNumber.includes(text)) {
        return true
      } else {
        return false
      }
    },
    handleSearchChange(search) {
      this.form = { ...this.form, ...search }
      this.getPage(1)
    },
    handlePageChange(page) {
      this.getPage(page)
    },
    cancelDialog() {
      this.showModal = false
    },
    confirmDialog() {
      if (this.manualData.customerId) {
        this.showModal = false
        const param = {
          id: this.manualData.id,
          customerId: this.manualData.customerId,
          IsAddRemittance: this.manualData.IsAddRemittance
        }
        this.manageStatement(param).then(ret => {
          this.getPage(this.paginateConfig.page)
          this.$store.commit('app/setNotification', {
            msg: this.$t('Views.Goods.actionSuccess'),
            type: 'success'
          })
        })
      } else {
        this.$store.commit('app/setNotification', {
          msg: this.$t('Views.Statement.clientNeeded'),
          type: 'warning'
        })
      }
    },
    getPermission(name) {
      return this.$util.tool.hasPerm(name)
    },
    importFlow() {
      this.$router.push({ path: '/account_statement/import_waterbill' })
    }
  }
}
</script>

<style lang="scss" scoped>
.auto-complete-container {
  position: relative;
  &:after {
    content: '*';
    color: red;
    position: absolute;
    top: 0;
    left: -10px;
  }
}
</style>
